import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

/** True when .env is filled in. The app shows a setup screen when it isn't. */
export const isConfigured = Boolean(url && anonKey)

/**
 * Browser client — ANON key only, every request subject to RLS.
 *
 * The service-role key lives exclusively in the Pages Functions and the cron
 * Worker. If you ever find yourself wanting it here, you want an API route.
 */
export const supabase: SupabaseClient = createClient(
  url || 'http://localhost:54321',
  anonKey || 'public-anon-key-placeholder',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: false,
      storageKey: 'lm-auth',
    },
  },
)
